"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _AdvancedModal = _interopRequireDefault(require("../../AdvancedModal"));
var _LodashExtensions = require("chaire-lib-common/lib/utils/LodashExtensions");
var _ServiceLocator = _interopRequireDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
// Converts seconds to minutes
// TODO Allow to change that divider and update unit string (#2079)
const defaultDurationDivider = 60;
class WidgetManagerSelector extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.onButtonClick = this.onButtonClick.bind(this);
  }
  componentDidMount() {
    _ServiceLocator.default.eventManager.on("taxi.filter.manageWidgets.request", this.handleOpen);
  }
  componentWillUnmount() {
    _ServiceLocator.default.eventManager.off("taxi.filter.manageWidgets.request", this.handleOpen);
  }
  handleOpen() {
    this.setState({
      isActive: true
    });
  }
  handleClose() {
    this.setState({
      isActive: false
    });
  }
  onButtonClick(widgetInfo, widgetOptions) {
    _ServiceLocator.default.eventManager.emit('taxi.filter.selectedWidgets.add', widgetInfo, widgetOptions);
    this.setState({
      isActive: false
    });
  }
  renderContainer() {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("button", {
      className: "_two_third_column _input _input-select-button _bottom_padding",
      style: {
        display: "inline-block"
      },
      type: "button",
      onClick: () => this.onButtonClick({
        object: "trips",
        labelName: "trips",
        type: "discrete",
        allowStatus: false
      }, {
        statusOption: "occupied"
      })
    }, this.props.t('octavi:filters:widgets:labelTrips')), /*#__PURE__*/_react.default.createElement("button", {
      className: "_two_third_column _input _input-select-button _bottom_padding",
      style: {
        display: "inline-block"
      },
      type: "button",
      onClick: () => this.onButtonClick({
        object: "activities",
        labelName: "activities",
        type: "discrete"
      })
    }, this.props.t('octavi:filters:widgets:labelActivities')), /*#__PURE__*/_react.default.createElement("button", {
      className: "_two_third_column _input _input-select-button _bottom_padding",
      style: {
        display: "inline-block"
      },
      type: "button",
      onClick: () => this.onButtonClick({
        object: "vehicles",
        labelName: "vehicles",
        type: "discrete"
      })
    }, this.props.t('octavi:filters:widgets:labelVehicles')), /*#__PURE__*/_react.default.createElement("button", {
      className: "_two_third_column _input _input-select-button _bottom_padding",
      style: {
        display: "inline-block"
      },
      type: "button",
      onClick: () => this.onButtonClick({
        object: "driver",
        labelName: "driver",
        type: "discrete"
      })
    }, this.props.t('octavi:filters:widgets:labelDrivers')), /*#__PURE__*/_react.default.createElement("button", {
      className: "_two_third_column _input _input-select-button _bottom_padding",
      style: {
        display: "inline-block"
      },
      type: "button",
      onClick: () => this.onButtonClick({
        object: "operators",
        labelName: "operators",
        type: "discrete"
      })
    }, this.props.t('octavi:filters:widgets:labelOperators')), /*#__PURE__*/_react.default.createElement("button", {
      className: "_two_third_column _input _input-select-button _bottom_padding",
      style: {
        display: "inline-block"
      },
      type: "button",
      onClick: () => this.onButtonClick({
        object: "distance",
        labelName: "distance",
        type: "continuous",
        divider: 1000
      })
    }, this.props.t('octavi:filters:widgets:labelDistance')), /*#__PURE__*/_react.default.createElement("button", {
      className: "_two_third_column _input _input-select-button _bottom_padding",
      style: {
        display: "inline-block"
      },
      type: "button",
      onClick: () => this.onButtonClick({
        object: "distance",
        labelName: "distance",
        type: "continuous",
        divider: 1000,
        allowStatus: false
      }, {
        statusOption: "occupied"
      })
    }, this.props.t('octavi:filters:widgets:labelDistanceTrip')), /*#__PURE__*/_react.default.createElement("button", {
      className: "_two_third_column _input _input-select-button _bottom_padding",
      style: {
        display: "inline-block"
      },
      type: "button",
      onClick: () => this.onButtonClick({
        object: "duration",
        labelName: "duration",
        type: "continuous",
        divider: defaultDurationDivider
      })
    }, this.props.t('octavi:filters:widgets:labelDuration')), /*#__PURE__*/_react.default.createElement("button", {
      className: "_two_third_column _input _input-select-button _bottom_padding",
      style: {
        display: "inline-block"
      },
      type: "button",
      onClick: () => this.onButtonClick({
        object: "duration",
        labelName: "duration",
        type: "continuous",
        divider: defaultDurationDivider,
        allowStatus: false
      }, {
        statusOption: "occupied"
      })
    }, this.props.t('octavi:filters:widgets:labelDurationTrip')));
  }
  render() {
    const {
      isActive,
      selectedWidgets
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(_AdvancedModal.default, {
      title: this.props.t('octavi:filters:widgets:popupTitle'),
      t: this.props.t,
      isOpen: isActive,
      container: this.renderContainer(),
      showCancelButton: true,
      showConfirmButton: false,
      closeModal: this.handleClose,
      isConfirmButtonDisabled: false
    });
  }
}
WidgetManagerSelector.propTypes = {
  t: _propTypes.default.func,
  i18n: _propTypes.default.object,
  activeSection: _propTypes.default.string
};
var _default = exports.default = (0, _reactI18next.withTranslation)()(WidgetManagerSelector);